import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Card } from '@comparethemarketau/manor-card';

import { ProductName } from '../common/product_name';
import { ProductPriceCard } from '../../products/products/widget/product_price_card';
import { GetInTouch } from '../../products/products/common/get_in_touch';
import { ProceedWithProvider } from '../../products/products/common/proceed_with_provider';
import { ProceedHelpText } from '../../products/products/common/proceed_help_text';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        border: 'unset'
    }
}));

const ProductCard = ({ quote }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <div className={classNames('test-policyProduct-card')}>
            <Card
                margin={['0', '0', '0', '0']}
                padding={['16']}
                boxShadow
                className={classes.container}
            >
                <ProductName quote={quote} />
                <ProductPriceCard quote={quote} />
                <GetInTouch quote={quote} />
                <ProceedWithProvider quote={quote} currentIndex={0} />
                <ProceedHelpText />
            </Card>
        </div>
    );
};

ProductCard.propTypes = {
    quote: PropTypes.object.isRequired
};

export { ProductCard };
